import React from 'react';

const LogoLoader = ({ 
  size = 'md', 
  text = 'Loading...', 
  fullScreen = false,
  className = '' 
}) => {
  const sizeClasses = {
    sm: 'w-20 h-20',
    md: 'w-28 h-28',
    lg: 'w-36 h-36',
    xl: 'w-44 h-44'
  };

  const textSizeClasses = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base',
    xl: 'text-lg'
  };

  const loader = (
    <div className={`flex flex-col items-center justify-center gap-4 ${className}`}>
      <div className="relative">
        {/* FOS Logo with smooth pulse animation */}
        <img 
          src="/fos-logo.png" 
          alt="Loading" 
          className={`${sizeClasses[size]} relative z-10 object-contain`}
          style={{ animation: 'pulse 1.5s ease-in-out infinite' }}
        />
      </div>
      
      {text && (
        <p className={`${textSizeClasses[size]} text-amber-800 font-medium animate-pulse`}>
          {text}
        </p>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-white/95 backdrop-blur-sm z-50 flex items-center justify-center">
        {loader}
      </div>
    );
  }

  return loader;
};

export default LogoLoader;
